import constants from '../config';

// Synchronous validators — return error string or null

export function validateEmail(email) {
  if (!email) return 'Email is required';
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(String(email).toLowerCase())) return 'Please enter a valid email address';
  return null;
}

export function validatePassword(password) {
  if (!password) return 'Password is required';
  const passw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
  if (!passw.test(password)) return 'Password must be at least 6 characters with uppercase, lowercase, and numbers';
  return null;
}

export function validateName(name) {
  if (!name || !name.trim()) return 'Name is required';
  return null;
}

export function validateUsername(username) {
  if (!username || !username.trim()) return 'Username is required';
  return null;
}

export function validateCountry(country) {
  if (!country || country === 'init') return 'Please choose a country';
  if (country !== 'United States') return 'We will be available in your country soon';
  return null;
}

// Password strength indicator
export function getPasswordStrength(password) {
  if (!password) return { valid: false, label: '', color: '' };
  const passw = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
  if (passw.test(password)) {
    return { valid: true, label: 'Strong Password', color: '#10b981' };
  }
  return { valid: false, label: "Make sure it's at least 6 characters long, contains capital letters and numbers", color: '#ef4444' };
}

// Async validators — call API to check uniqueness

export function checkEmailUnique(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(String(email).toLowerCase())) return Promise.resolve(false);

  return fetch(`${constants.DOMAIN}/api/v1/guest/signup?search=${encodeURIComponent(email)}`, {
    mode: 'cors',
    method: 'GET',
  })
    .then(r => r.json())
    .then(res => !!res.result) // true = unique/available
    .catch(() => false);
}

export function checkUsernameUnique(username) {
  if (!username) return Promise.resolve(false);
  const emailRe = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return fetch(`${constants.DOMAIN}/api/v1/guest/user?search=${encodeURIComponent(username)}`, {
    mode: 'cors',
    method: 'GET',
  })
    .then(r => r.json())
    .then(res => res.result && !emailRe.test(String(username).toLowerCase())) // true = available and not an email format
    .catch(() => false);
}
